import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Oferta1la1Problem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1813">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1814">
        <SectionHeading title="Te-ai săturat să te lovești de aceleași ziduri invizibile?" data-id="element-1815" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-1816">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-1817">
            <p className="font-bold text-xl text-brand-text" data-id="element-1818">
              Citești, meditezi, mergi la cursuri. Înțelegi conceptele.
              Aplicați. Și totuși, ceva tot se repetă.
            </p>
            <p data-id="element-1819">
              Aceleași tipare în relații, în bani, în carieră, în corp. Ca și
              cum o parte din tine vrea schimbarea, iar alta o sabotează fără să
              îți dai seama. Și nu e vina ta. E vorba de credințe profunde din
              subconștient — moștenite, formate în copilărie, instalate tăcut —
              care îți spun „nu pot", „nu merit", „nu e sigur să reușesc". Le
              repeți fără să le auzi, dar ele îți modelează viața.
            </p>
            <p data-id="element-1820">
              Cursurile și cărțile te ajută. Dar uneori ai nevoie de cineva care
              lucrează direct cu tine, care vede ce alții nu văd, care
              identifică credința exactă și o transformă la rădăcină. Asta face
              o ședință 1 la 1 de Theta Healing®.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-1821">
              <p className="font-medium text-brand-text italic" data-id="element-1822">
                Theta Healing® este o tehnică prin care accesăm starea theta a
                creierului — aceeași stare în care se imprimă credințele în
                copilărie — și în care ele pot fi schimbate. Lucrul 1 la 1 îți
                oferă atenție completă, ghidare personalizată și acces la
                straturi pe care le-ai purtat ani de zile fără să le
                conștientizezi.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1823">
          <CTAButton data-id="element-1824" />
        </motion.div>
      </div>
    </section>;
}